import React from "react";
import styles from "../styles/Thank-you.module.css";
import PricingCard from "./PricingCard";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import useWindowSize from '../hooks/useWindowSize';
import { pricingData } from '../data/pricingData';

const PricingSection: React.FC = () => {
  const { width } = useWindowSize();

  return (
    <section className={styles.pricingSection}>
      {width && width < 992 ? (
        <Swiper
          spaceBetween={15}
          slidesPerView={1.25}
          centeredSlides={true}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          initialSlide={1} // Start with the second card
        >
          {pricingData.map((card, index) => (
            <SwiperSlide key={index}>
              <PricingCard {...card} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className={styles.pricingContainer}>
          {pricingData.map((card, index) => (
            <PricingCard key={index} {...card} />
          ))}
        </div>
      )}
    </section>
  );
};

export default PricingSection;
